import http from "@/plugins/axios";

export default {
    queryStopTradingAlarm(){
        return http.get({
            url:'/admin/riskcontrol/queryStopTradingAlarm',
        })
    },

    addOrUpdateStopTradingAlarm(data){
        return http.post({
            url: '/admin/riskcontrol/addOrUpdateStopTradingAlarm',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    queryPriceDifferenceAlarm(){
        return http.get({
            url:'/admin/riskcontrol/queryPriceDifferenceAlarm',
        })
    },

    addOrUpdatePriceDifferenceAlarm(data){
        return http.post({
            url: '/admin/riskcontrol/addOrUpdatePriceDifferenceAlarm',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    queryPriceAlarm(){
        return http.get({
            url:'/admin/riskcontrol/queryPriceAlarm',
        })
    },

    addOrUpdatePriceAlarm(data){
        return http.post({
            url: '/admin/riskcontrol/addOrUpdatePriceAlarm',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    queryInsufficientDepthAlarm(){
        return http.get({
            url:'/admin/riskcontrol/queryInsufficientDepthAlarm',
        })
    },

    addOrUpdateInsufficientDepthAlarm(data){
        return http.post({
            url: '/admin/riskcontrol/addOrUpdateInsufficientDepthAlarm',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    queryMovingBricksAlarm(){
        return http.get({
            url:'/admin/riskcontrol/queryMovingBricksAlarm',
        })
    },

    addOrUpdateMovingBricksAlarm(data){
        return http.post({
            url: '/admin/riskcontrol/addOrUpdateMovingBricksAlarm',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    queryThirdPartyExchange(){
        return http.get({
            url:'/admin/riskcontrol/queryThirdPartyExchange',
        })
    },


    queryAssetsChangeAlarm(){
        return http.get({
            url:'/admin/riskcontrol/queryAssetsChangeAlarm',
        })
    },

    addOrUpdateAssetsChangeAlarm(data){
        return http.post({
            url: '/admin/riskcontrol/addOrUpdateAssetsChangeAlarm',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    queryFindNeedHedgeAlarm(){
        return http.get({
            url:'/admin/riskcontrol/findNeedHedgeAlarm',
        })
    },

    addOrUpdateFindNeedHedgeAlarm(data){
        return http.post({
            url: '/admin/riskcontrol/addOrUpdateNeedHedgeAlarm',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },


}